"use client"

import TablaRrhhTurnosComponent from "./TablaRrhhTurnosComponent.js"

const RrhhTurnosComponent = () => {
  return <TablaRrhhTurnosComponent />
}

export default RrhhTurnosComponent
